import React from "react";
import CommonDocumentModuleInterface from "@/pages/T4/CommonDocumentModuleInterface";

interface ViewOnboardingDocumentsProps {}

const ViewOnboardingDocuments: React.FC<ViewOnboardingDocumentsProps> = () => {
  return (
    <>
      <CommonDocumentModuleInterface isView={true} />
    </>
  );
};

export default ViewOnboardingDocuments;
